// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'customTheme1',
    variations: {
      colors: ['primary', 'secondary'],
      lighten: 3,
      darken: 3,
    },
    themes: {
      customTheme1: {
        light: true,
        colors: {
          background: '#f8f8f8',
          primary: '#376d9a'
        }
      }
    }
  }
})
